import { useEffect, useState } from "react";
import PrivacyPolicy2026ToNow from "./2026.06.01~now";
import PrivacyPolicy2014To2026 from "./2014.03.07~2026.05.31";
import { useRouter } from "src/hooks/useRouter";


interface IPrivacyPolicyProps {
    defaultVersion?: "2026" | "2014"
}
// 개인정보 전문
const PrivacyPolicy = ({ defaultVersion = "2026" }: IPrivacyPolicyProps) => {
    const [selectedVersion, setSelectedVersion] = useState<"2026" | "2014">(defaultVersion);
    const { lang } = useRouter();
    useEffect(() => {
        if (lang === "en") {
            setSelectedVersion("2014");
        } else {
            setSelectedVersion(defaultVersion);
        }
    }, [lang, defaultVersion])
    return (
        <div>
            {selectedVersion === "2026" && <PrivacyPolicy2026ToNow />}
            {selectedVersion === "2014" && <PrivacyPolicy2014To2026 />}
            {lang !== "en" && <>
                <h3 className="title">이 전의 개인정보 처리방침은 아래에서 확인할 수 있습니다.</h3>
                <div style={{ display: "flex", gap: "10px", marginBottom: "20px", flexDirection: "column", width: "fit-content", fontSize: "16px" }}>
                    <span
                        onClick={(e) => {
                            e.preventDefault();
                            setSelectedVersion("2026");
                        }}
                        style={{
                            color: selectedVersion === "2026" ? "#15c56d" : "#888",
                            fontWeight: selectedVersion === "2026" ? "bold" : "normal",
                            textDecoration: selectedVersion === "2026" ? "underline" : "none",
                            cursor: "pointer",
                        }}
                    >
                        2026.06.01~
                    </span>
                    <span
                        onClick={(e) => {
                            e.preventDefault();
                            setSelectedVersion("2014");
                        }}
                        style={{
                            color: selectedVersion === "2014" ? "#15c56d" : "#888",
                            fontWeight: selectedVersion === "2014" ? "bold" : "normal",
                            textDecoration: selectedVersion === "2014" ? "underline" : "none",
                            cursor: "pointer",
                        }}
                    >
                        2014.03.07~2026.05.31
                    </span>
                </div>
            </>
            }
        </div>
    );
};

export default PrivacyPolicy;